import { useFeatureIsOn } from '@frontend/react';
import { Text, XStack, isMobile } from '@frontend/web-react';
import { applyClass, concatClasses } from '@frontend/web-utils';
import { HeaderButton } from '@frontend/web/components';
import { spotlight } from '@mantine/spotlight';

export const TasksHeader = ({ isButtonHidden, title = 'Tasks' }: { isButtonHidden?: boolean; title?: string }) => {
  const { enabled: isGameplanPricingEnabled } = useFeatureIsOn('is_gameplan_pricing_enabled');

  const handleSearchClick = () => {
    // Use a small delay on mobile to ensure touch event completes
    if (isMobile) {
      setTimeout(() => spotlight.open(), 50);
    } else {
      spotlight.open();
    }
  };
  return (
    <XStack
      className={concatClasses(
        'justify-between items-center w-full py-lg',
        applyClass(isGameplanPricingEnabled, 'px-none pb-none', 'px-md'),
      )}
    >
      <Text className={applyClass(isGameplanPricingEnabled, 'text-neutral-950')} type="h3">
        {title}
      </Text>
      {isButtonHidden ? null : (
        <XStack className="gap-md">
          <HeaderButton accessibilityLabel="Search tasks" color="primary" iconName="IconSearch" onClick={handleSearchClick} />
        </XStack>
      )}
    </XStack>
  );
};
